export default "__VITE_ASSET__V$Z7LIF7__"